import { TabsWrapper } from './styles';

interface IProps {
    tabKey: string;
}

const Tabs = (props: IProps) => {
    return (
        <TabsWrapper className='xtabs' style={{ paddingTop: 0 }}>
            <div className='nav nav-tabs' style={{ marginBottom: 0 }}>
                <li className={props.tabKey == 'SWAP' ? 'active' : ''}><a href={'/admin/donors'}><span>Donor Search</span></a></li>
                <li className={''}><a href={'/admin/reports/dash-board/compare-conversion?sites%5B%5D=nkr&centerType=dcn&min=0&organType=1&isMicrosite=-1'}><span>Dashboard</span></a></li>
                <li className={''}><a href={`admin/dash/donor-intake/search`}><span>PWL</span></a></li>
                {/*<li className={''}><a href={`${__OUTSIDEURL__}/admin/donor/active_ndds.php`}><span>Active NDDs</span></a></li>
                <li className={''}><a href={`${__OUTSIDEURL__}/admin/donor/inactive_ndds.php`}><span>Inactive NDDs</span></a></li>
                <li className={''}><a href={`${__OUTSIDEURL__}/admin/donor/donor_updates.php`}><span>Donor Updates</span></a></li>*/}
            </div>
        </TabsWrapper>
    );
}

export default Tabs;